export interface ICOSFormWorkAddress {
  address: string;
  address2: string;
  city: string;
  county?: string;
  postcode: string;
}

export interface ICOSForm {
  cos_tier: string;
  cos_sponsor_licence_number: string;
  cos_sponsor_name: string;
  cos_number: string;
  cos_issue_date: string;
  cos_expiry_date: string;
  cos_note: string;
  cos_last_name: string;
  cos_first_name: string;
  cos_other_name_n_: string;
  cos_nationality_n_: string;
  place_of_birth: string;
  country_of_birth: string;
  date_of_birth: string;
  gender: string;
  national_insurance_number: string;
  employee_number: string;
  cos_work_start_date: string;
  cos_work_end_date: string;
  if_to_leave_uk: boolean;
  hours_work: string;
  job_title: string;
  job_type: string;
  job_description: string;
  if_client_contract: boolean;
  client_contract_details: string;
  basic_salary: string;
  migrant_salary_for_each: string;
  salary_and_allowances: string;
  allowances: string;
  job_title_shortage_list: boolean;
  maintenance_status: boolean;
  registration_details: string;
  atas_required: boolean;
  phd_required_for_post: boolean;
  if_passed_rlmt: boolean;
  work_address?: ICOSFormWorkAddress;
  other_work_addresses?: ICOSFormWorkAddress[];
}

export interface ICOSFormCompliance {
  cos_tier: string;
  cos_sponsor_licence_number: string;
  cos_sponsor_name: string;
  cos_number: string;
  cos_issue_date: string;
  cos_expiry_date: string;
  cos_note: string;
  cos_last_name: string;
  cos_first_name: string;
  cos_other_name_n_: string;
  cos_nationality_n_: string;
  place_of_birth: string;
  country_of_birth: string;
  date_of_birth: string;
  gender: string;
  cos_gender: string;
  national_insurance_number: string;
  employee_number: string;
  cos_work_start_date: string;
  cos_work_end_date: string;
  if_to_leave_uk: boolean;
  hours_work: string;
  job_title: string;
  job_type: string;
  job_description: string;
  if_client_contract: boolean;
  client_contract_details: string;
  basic_salary: string;
  migrant_salary_for_each: string;
  salary_and_allowances: string;
  allowances: string;
  job_title_shortage_list: boolean;
  maintenance_status: boolean;
  registration_details: string;
  atas_required: boolean;
  phd_required_for_post: boolean;
  if_passed_rlmt: boolean;
  work_address?: ICOSFormWorkAddress;
  other_work_addresses?: ICOSFormWorkAddress[];
}

export interface ICOSFormCases {
  cos_tier: string;
  cos_sponsor_licence_number?: string;
  sponsor_licence_number?: string;
  cos_number: string;
  cos_issue_date: string;
  cos_expiry_date: string;
  cos_note: string;
  sponsor_note?: string;
  confirm_creative_contribution?: string;
  place_of_birth: string;
  country_of_birth: string;
  cos_gender?: string;
  gender?: string;
  national_insurance_number: string;
  employee_number: string;
  cos_work_start_date: string;
  cos_work_end_date: string;
  hours_work: string;
  job_title: string;
  job_type: string;
  job_description: string;
  if_new_entrant: string;
  basic_salary: string;
  salary_and_allowances: string;
  migrant_salary_for_each: string;
  allowances: string;
  job_title_shortage_list: boolean;
  maintenance_status: boolean;
  atas_required: boolean;
  if_client_contract: boolean;
  client_contract_details: string;
  phd_required_for_post: boolean;
  work_address?: ICOSFormWorkAddress;
  other_work_addresses?: ICOSFormWorkAddress[];
}

export const keysFormCases = new Set<keyof ICOSFormCases>([
  "cos_tier",
  "cos_sponsor_licence_number",
  "cos_number",
  "cos_issue_date",
  "cos_expiry_date",
  "cos_note",
  "sponsor_note",
  "confirm_creative_contribution",
  "place_of_birth",
  "country_of_birth",
  "cos_gender",
  "national_insurance_number",
  "employee_number",
  "cos_work_start_date",
  "cos_work_end_date",
  "hours_work",
  "job_title",
  "job_type",
  "job_description",
  "if_new_entrant",
  "basic_salary",
  "salary_and_allowances",
  "migrant_salary_for_each",
  "allowances",
  "job_title_shortage_list",
  "maintenance_status",
  "atas_required",
  "if_client_contract",
  "client_contract_details",
  "phd_required_for_post",
  "work_address",
  "other_work_addresses",
]);

export const keysFormCompliance = new Set<keyof ICOSForm>([
  "cos_tier",
  "cos_sponsor_licence_number",
  "cos_sponsor_name",
  "cos_number",
  "cos_issue_date",
  "cos_expiry_date",
  "cos_note",
  "cos_last_name",
  "cos_first_name",
  "cos_other_name_n_",
  "cos_nationality_n_",
  "place_of_birth",
  "country_of_birth",
  "date_of_birth",
  "gender",
  "national_insurance_number",
  "employee_number",
  "cos_work_start_date",
  "cos_work_end_date",
  "if_to_leave_uk",
  "hours_work",
  "job_title",
  "job_type",
  "job_description",
  "if_client_contract",
  "client_contract_details",
  "basic_salary",
  "migrant_salary_for_each",
  "salary_and_allowances",
  "allowances",
  "job_title_shortage_list",
  "maintenance_status",
  "registration_details",
  "atas_required",
  "phd_required_for_post",
  "if_passed_rlmt",
  "work_address",
  "other_work_addresses",
]);
